import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { Link } from "react-router-dom";

export const Wrapper = ({ children }) => {
  return (
    <ul className="flex flex-col flex-1 overflow-auto px-3 gap-1">
      {children}
    </ul>
  );
};

export const List = ({ children, className, active, icon, ...props }) => {
  const Icon = icon;
  return (
    <li>
      <Link
        className={
          "rounded-lg px-3 py-2.5 text-sm font-semibold flex items-center transition-colors " +
          (active
            ? "bg-primary-500 text-white-100 shadow-sm"
            : "text-black-300 hover:bg-white-200 hover:text-black-200")
        }
        {...props}
      >
        <span className="w-8 text-center text-lg">
          <Icon />
        </span>
        {children}
      </Link>
    </li>
  );
};

export const DropdownList = ({
  children,
  className,
  active,
  icon,
  onClick = () => {},
  dropdown = [],
  dropdownActive,
  dropdownOnClick = () => {},
  ...props
}) => {
  const Icon = icon;
  const [show, setShow] = useState(active);
  return (
    <li>
      <button
        onClick={(e) => {
          setShow((value) => !value);
          onClick(e);
        }}
        className={
          "rounded-lg px-3 py-2.5 text-sm font-semibold flex items-center w-full transition-colors" +
          (!active
            ? " text-black-300 hover:bg-white-200 hover:text-black-200"
            : !show
            ? " bg-primary-500 text-white-100 shadow-sm"
            : " text-black-300")
        }
        type="button"
        {...props}
      >
        <span className="w-8 text-center text-lg">
          <Icon />
        </span>
        {children}
        <FiChevronDown
          className={`ml-auto transition duration-300 transform ${
            show ? "rotate-0" : "-rotate-90"
          }`}
        />
      </button>
      <ul
        className={`ml-8 mt-1 border-l border-white-300 pl-3 transition-all duration-300 overflow-hidden ${
          show ? "max-h-full" : "max-h-0"
        }`}
      >
        {dropdown.map((item, index) => (
          <li className="mt-1" key={`menu-${index}`}>
            <Link
              className={
                "block px-3 py-2 rounded-lg text-sm font-medium transition-colors " +
                (dropdownActive === item.title
                  ? "bg-primary-500 text-white-100"
                  : "text-black-300 hover:bg-white-200 hover:text-black-200")
              }
              to={item.to}
              onClick={() => {
                dropdownOnClick(index);
              }}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};
